export var AccountActionErrors;

(function (AccountActionErrors) {
  AccountActionErrors["INVALID_EVENT_ID"] = "invalid.event.id";
})(AccountActionErrors || (AccountActionErrors = {}));
//# sourceMappingURL=AccountActionErrors.js.map